// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const PlayIcon = (props: IconProps) => (
  <Icon viewBox="0 0 15 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90032 1.55246C2.36752 1.20526 1.6793 1.5693 1.6793 2.22464V15.7093C1.6793 16.3647 2.36766 16.7288 2.90049 16.3814C2.90065 16.3813 2.90033 16.3815 2.90049 16.3814L13.1658 9.64174C13.6505 9.31506 13.6505 8.61892 13.1658 8.29224L2.90032 1.55246C2.90011 1.55231 2.90054 1.5526 2.90032 1.55246ZM0.279297 2.22464C0.279297 0.465072 2.19544 -0.579706 3.66632 0.380599L3.66783 0.381583L13.9425 7.12742C15.2582 8.00846 15.2582 9.9255 13.9425 10.8065L13.9372 10.8101L3.66783 17.5524L3.66632 17.5534C2.19544 18.5137 0.279297 17.4689 0.279297 15.7093V2.22464Z"
      fill="currentColor"
    />
  </Icon>
);
